import { render, staticRenderFns } from "./navig-ator.vue?vue&type=template&id=899f7a74&scoped=true"
import script from "./navig-ator.vue?vue&type=script&lang=js"
export * from "./navig-ator.vue?vue&type=script&lang=js"
import style0 from "./navig-ator.vue?vue&type=style&index=0&id=899f7a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899f7a74",
  null
  
)

export default component.exports